<template>

  <Head title="Forgot Password" />
  <div class="hold-transition login-page">
    <div class="login-box">
      <div class="card card-outline card-primary">
        <div class="card-header text-center">
          <a href="#" class="h1">
            <b>KUNJUNGAN</b>
          </a>
        </div>
        <div class="card-body">
          <div v-if="status" class="alert alert-success text-center">Reset Sandi Terkirim, cek email Anda !</div>
          <p class="login-box-msg">
            Anda lupa kata sandi Anda? kirim permintaan melalui email anda.
          </p>
          <form @submit.prevent="submit">
            <input-group placeholder="Email" class="fas fa-envelope" v-model="form.email" :error="form.errors.email" />
            <div class="row">
              <div class="col-12">
                <button type="submit" class="btn btn-primary btn-block" :disabled="form.processing">
                  Minta kata sandi baru
                </button>
              </div>
            </div>
          </form>
          <p class="mt-3 mb-1">
            <a href="/login">Login</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import InputGroup from '@/Forms/InputGroup'

export default {
  components: {
    Head,
    InputGroup,
  },
  props: {
    status: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: null,
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/forgot-password')
    },
  },
}
</script>

<style>
.login-page {
  /* The image used */
  /* background-image: url("/background.jpg"); */
  background: rgba(0, 0, 0, .65) url("/default/background.jpg");
  background-blend-mode: darken;

  /* Control the height of the image */
  min-height: 380px;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>
